// extracted by mini-css-extract-plugin
export default {"iframe":"Launcher_iframe--Y15","leap-virtual-sports":"Launcher_leap-virtual-sports--GoF","x2-bet-virtual-sports":"Launcher_x2-bet-virtual-sports--3Tq"};